/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  Grid,
  Checkbox,
  Button,
  Icon,
} from 'semantic-ui-react';
import clone from 'clone';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import config from '../../config';
import { isPricingPackageLocked, vnPackageLockMessage } from '../utils/vietnamPricing';

class CustomiseFeePackageFormulaModal extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      isSuperAdmin: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
    }),
    bookingData: PropTypes.shape(),
    isMobile: PropTypes.bool,
    loading: PropTypes.bool,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    serviceCompanyID: PropTypes.string,
    t: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const { bookingData, open } = props;
    let formulas = [];
    // control modal state externally instead of based on trigger if modalState provided
    if (open && bookingData && bookingData.packageFee && bookingData.packageFee.items && bookingData.packageFee.items.length > 0) {
      formulas = clone(bookingData.packageFee.items);
    }
    return {
      formulas,
    };
  }

  constructor(props) {
    super(props);
    const state = CustomiseFeePackageFormulaModal.getPropsToState(props);
    this.state = {
      ...state,
    };
  }

  componentWillReceiveProps(nextProps) {
    const state = CustomiseFeePackageFormulaModal.getPropsToState(nextProps);
    this.setState({ ...state });
  }

  getDevPPUrl = () => {
    const { bookingData, serviceCompanyID } = this.props;
    const projectUrl = `${config.get('developerURL')}/c/${serviceCompanyID}/projects/${bookingData.projectID}/`;
    if (bookingData && bookingData.packageFee && bookingData.packageFee.projectFeePackageID && serviceCompanyID) {
      return projectUrl.concat(`additional_fees/${bookingData.packageFee.projectFeePackageID}`);
    }
    return projectUrl.concat('edit?tab=additional_fees');
  }

  handleOnChange = (e, target) => {
    const { value, checked } = target;
    const { formulas } = this.state;
    const updatedFormulas = [...formulas];
    if (updatedFormulas.length > 0) {
      const idx = updatedFormulas.findIndex(ci => ci.id === value);
      if (idx !== -1) {
        updatedFormulas[idx].isEnabled = checked;
      }
      this.setState({ formulas: updatedFormulas });
    }
  }

  handleSubmit = () => {
    const { formulas } = this.state;
    const { onSubmit, onClose } = this.props;
    if (onSubmit) {
      onSubmit(formulas);
    }
    onClose();
  };

  renderOptions = () => {
    const { formulas } = this.state;
    const cItems = [];
    if (formulas.length > 0) {
      formulas.forEach((item) => {
        cItems.push({
          id: item.id,
          name: item.name,
          checked: item.isEnabled,
          disabled: item.isRequired,
        });
      });
    }
    return cItems;
  }

  renderFields = items => items && items.map((item) => {
    return (
      <section
        className="checkboxContainer"
        key={item.id}
      >
        <Checkbox
          value={item.id}
          checked={item.checked}
          onChange={this.handleOnChange}
          disabled={item.disabled}
        />
        <div className="checkboxLabel">
          <p className="text-title">{item.name}</p>
        </div>
      </section>
    );
  })

  render() {
    const { bookingData, loading, t } = this.props;
    const options = this.renderOptions();
    // CPI-977 requirements 7/11: belt and braces - the modal is also reachable by a deep link.
    const statusID = bookingData && bookingData.statusID;
    if (isPricingPackageLocked(this.props.auth, statusID, 'fee')) {
      return (
        <section className="edit_package_pricing">
          <p className="text-body">
            <Icon name="lock" />
            {this.props.t(vnPackageLockMessage(this.props.auth, statusID, 'fee'))}
          </p>
        </section>
      );
    }
    return (
      <section className="edit_package_pricing">
        <p className="text-header">{t('Fee formula(s)', { ns: TRANSLATION_FILES.translation })}</p>
        <Grid columns={1}>
          <Grid.Row>
            <Grid.Column>
              {this.renderFields(options)}
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <p>
                {t('Would you like to add more fee formula? Go to', { ns: TRANSLATION_FILES.translation })}&nbsp;
                <a className="link" href={this.getDevPPUrl()}>{t('Additional Fees', { ns: TRANSLATION_FILES.translation })}</a>&nbsp;
                {t('to add, remove or edit fee formula(s).', { ns: TRANSLATION_FILES.translation })}
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid columns={1}>
          <Grid.Row>
            <Grid.Column textAlign="right">
              <Button
                content={t('Save', { ns: TRANSLATION_FILES.translation })}
                disabled={!bookingData || !bookingData.packageFeeID}
                loading={loading}
                className="submit-button text-title"
                onClick={this.handleSubmit}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </section>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(CustomiseFeePackageFormulaModal);



// WEBPACK FOOTER //
// ./src/components/CustomiseFeePackageFormulaModal.jsx